import actionTypes from "../actions/actionTypes"
import { createItemsReducer } from "../../../common/utils/redux-helper"
import { ENTITY_TYPES } from "../../../common/utils"

export default createItemsReducer(actionTypes, ENTITY_TYPES.ARTICLES)
